<breadcrumb-navigation [titles]="[{ key: 'MY_CONSENT', url: ''}, { key: 'PRIVACY_TERMS_OF_USE', url: ''}]"></breadcrumb-navigation>

<div class="user-terms">
  <div>
    <div class="top-title sm:px-4 sm:text-2xl sm:items-baseline">博世智能出行售后经销商门户</div>
    <div class="top-tip sm:px-4 sm:text-lg" >{{ "Data_PROTECTION_POLICY_BY_COMPANY" | translate }}</div>
  </div>
  <div class="px-4 py-8 sm:p-4">
    <h3 class="title sm:text-2xl">博世智能出行售后经销商门户</h3>
    <p class="pb-8">欢迎您使用“博世智能出行售后经销商门户”（以下简称本系统）。本系统所提供的各项服务的所有权和运作权归博世汽车技术服务（中国）有限公司上海分公司（以下简称“本公司”或“博世公司”）所有 。请您在使用本系统的所有服务前，仔细阅读本《博世智能出行售后经销商门户使用条款》（以下简称“本条款”或“本协议”）。您在同意本协议各项条款及隐私条款并完成账户激活程序后，才能成为本系统的正式客户并且使用本系统提供的相关服务。</p>
    <p class="subtitle sm:text-lg"><b>1.定义</b></p>
    <p>如无特殊说明，下列用语在本协议中的含义为：</p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">1.1. 博世智能出行售后经销商门户：指博世公司提供给客户的一种通过网络和电子终端以在线对话的方式自动实现博世公司自有产品（以下简称“博世公司产品”）信息的查询和订购的电子商务网站。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">1.2. 帐户：是指根据客户的申请，由博世公司提供给客户的用于在本系统上对博世公司产品进行查询和/或订购博世公司产品的具有唯一性的工具。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">1.3. 授权代表：经客户授权的对博世公司提供的本系统的帐户进行实际使用的人。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">1.4. 密码：是指由授权代表在本系统自助设置的用于在本系统对博世公司产品进行查询和/或订购的密码。</span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>2. 承诺</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">2.1. 客户承诺遵守本协议的约定及博世公司在本系统上公布的不时更新的交易规则。
            </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">2.2. 本协议约定的电子商务模式不改变博世公司的销售政策。博世公司的“交货一般条款和条件 A17”同样适用于通过本系统处理的客户订单。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">2.3. 客户和博世公司应当遵守中华人民共和国的有关法律和法规的规定。 </span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>3. 对客户的电子商务授权</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">3.1. 客户的用户权限包括（1）标准用户，和（2）受限制用户：本系统标准用户的权限包括拥有对博世公司产品信息的访问权，以及通过本系统向博世公司出具具有约束力的订单。受限制用户的权限是指只有对产品信息的访问权，但是无权通过本系统向博世公司出具具有约束力的订单。
            </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">3.2. 根据客户的不同需求，博世公司审核通过后，将为每个客户开立至少一个标准用户帐户。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">3.3. 开立帐户须由客户填写本系统申请表格以申请用户帐户，申请表格应当由客户的法定代表人签字并加盖公司公章并将原件提供给博世公司。同时，客户在申请表上应指定用户姓名作为授权代表。如客户的授权代表发生任何变动，客户应于1个工作日内填写申请表格并书面通知博世公司，博世公司不对授权代表变动所造成的损失承担任何责任。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">3.4. 博世公司在收到上述 3.3 条约定的申请表格后，会将帐户直接提供给授权代表， 经过授权代表在本系统认证邮箱及手机号、设置密码并确认同意系统使用条款及隐私声明后可激活账户。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">3.5. 客户无须支付本系统用户费，但是因使用本系统而产生的电费、因特网的费用和其他相关费用应当由客户自行承担。</span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>4. 博世公司的权利和义务</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">4.1. 博世公司有权根据客户资信情况，决定是否受理客户的要求开立帐户的申请。
            </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.2. 博世公司具有对本系统进行升级、改造的权利。博世公司有权根据系统升级等需要暂时中止本系统服务。客户不得因此追究博世公司的任何责任。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.3. 如博世公司发现客户不遵守博世公司有关业务规定或存在恶意操作、诋毁、损害博世公司声誉等情况的，博世公司有权单方终止对客户提供本系统服务，而无需承担任何费用、处罚或责任，该等终止于该等通知所载明的日期起生效，并保留追究客户责任的权利。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.4. 博世公司有权对所有使用客户的帐户、密码进行操作均视为客户作为，该操作产生的订单对客户具有法律约束力，该操作所产生的电子信息记录均为博世公司处理业务的有效凭证。  </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.5. 因以下情况导致的查询信息错误或没有正确执行客户提交的订单且因此导致客户直接损失的，博世公司不承担任何责任：</span>
            <ol class="list">
                <li> 博世公司接收到的信息不明、存在乱码、不完整等；</li>
                <li> 客户未能按照博世公司的有关业务规定正确操作；</li>
                <li> 客户的行为出于欺诈、胁迫或其他非法目的；</li>
                <li> 恶意串通，损害国家、集体、博世公司及其关联公司或者第三方利益的；</li>
                <li> 不可抗力或其他不可归因于博世公司的通讯、网络、电脑、病毒攻击、黑客行为、电力系统故障等突发意外情形。</li>
            </ol>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.6. 如因本系统差错、故障或其他原因导致产品的价格紊乱，客户不得依此要求订立协议，如因此而使客户获得不当得利的，客户应在博世公司提出书面要求后1个工作日内退还相应的款项。若延迟退还的，每延迟一日应向博世公司支付金额相当于应退还款项总额0.5%的滞纳金。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.7. 博世公司有义务对所有客户的帐户和密码严格保密。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.8. 系统升级和维护时，博世公司应在合理期限内通知客户。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.9. 博世公司具有所有本系统的系统管理权。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">4.10. 在任何情况下，博世公司均不对间接损失（包括但不限于利润损失、生产中断的损失等）承担责任。 </span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>5. 客户的权利和义务</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">5.1. 客户有权自愿申请成为本系统的用户，经博世公司批准并自行激活账户后，方可使用。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.2. 客户有权随时申请变更、注销帐户，博世公司将基于客户的书面请求为客户变更或注销本系统账户。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.3. 客户对本系统上公布的产品价格和信息有疑问的，可直接与博世公司的客户服务中心联系。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.4. 客户应当将帐户、密码严格保密，不得提供给他人使用。客户应当对其帐户和密码下发生的所有的活动承担全部责任。因客户在对帐户和密码的使用过程中存在过错或过失，导致博世公司因此受到损失和损害的，客户应当承担全部责任。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.5. 客户应当确保只有经其授权的授权代表登陆本系统访问博世公司的产品信息和发出订单。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.6. 客户有权在使用本系统之前接受博世公司的客户培训和本系统培训。对本系统的使用应当严格遵守客户培训和本系统培训手册。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.7. 客户通过本系统向博世公司出具的订单与以传统方式出具的订单具有同等约束力。如果输入错误，客户应当立刻与博世公司销售经理联系。博世公司有权根据其合理判断，决定是否修改订单。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.8. 客户不得以任何方式通过本系统获取任何尚未被博世公司授权获取的信息。客户应当销毁任何错误发送给它的信息。任何企图获取未被博世公司授权的信息的行为应当被视为非法行为。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.9. 博世公司在本系统上公布的产品价格信息为博世公司的保密信息，客户有义务保障本系统上的产品价格信息不被任何未经授权的个人或组织获取。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.10. 客户应当确保访问本系统的硬件和软件的安全，防止病毒对使用本系统的干扰。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.11. 客户可以致电博世公司客户服务热线寻求支持。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">5.12. 客户在此确认，其提供给博世公司的个人信息以及客户与博世公司之间的数据交换和授权处理均已取得个人事先授权同意，博世公司无需再次取得个人用户的同意。对于个人信息，客户应遵守有关保护个人隐私的法律规定，并采取必须的技术及管理措施保护该等信息，例如但不限于，防止未经授权的访问、未经授权的修改或传递，尤其通过网络传输该等信息。 </span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>6. 协议期限与终止</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">6.1 博世公司有权基于双方合作情况终止本协议并取消客户的本系统帐户，而无需任何原因且无需承担任何费用、处罚或责任，该等终止于该等通知所载明的日期起生效。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">6.2 但如果客户违反任何法律法规的规定，或本协议的任何条款和条件或本系统上的任何规定，博世公司有权立即终止本协议，并取消客户的本系统帐户，而且无须提前通知或承担任何法律责任。 </span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">6.3 客户的所有帐户注销之日起，本协议自行终止。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">6.4 协议终止并不意味着终止前所生效的订单的撤销，也不能消除因终止前的交易所带来的任何法律后果。</span>
        </li>
    </ul>
    <p class="subtitle sm:text-lg"><b>7. 版权和商标</b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">博世汽车技术服务（中国）有限公司上海分公司拥有本系统内所有内容（包括但不限于：文字、图片、软件、图形、音像及声音内容、Logo标识、版面设计、专栏目录与名称、商品分类等）的著作权及本系统中涉及的任何其他知识产权或已经合法取得其他知识产权人的许可。本系统上所有公示内容，包括网站本身及其附属的信息、本系统展示的产品、设计等均属于博世公司及其关联公司或博世公司的合作伙伴，并且受到中国知识产权法律保护。除了出于个人非营利性目的的使用，您不得通过电子邮件或其他任何方式使用、展示、复制、转发、修改、散布、传播、出售、出版、创造衍生产品、广播、发行或以任何方式利用全部或部分本系统的内容。在没有得到博世公司明确书面授权的情况下不得使用本系统所涉及的内容、设计。 以上属本公司拥有的所有内容未经授权，任何单位及个人不得用于商业、盈利、广告等目的，违反者将追究其法律责任。</span>
        </li>
    </ul>
    <div class="A-List A-List--unordered">
      <p class="subtitle sm:text-lg"><b>8. 法律与争议解决</b></p>
      <p>本协议适用中华人民共和国法律。双方在履行本协议的过程中，如发生争议， 应协商解决。无法解决的，任何一方均有权将争议提交至中国国际经济贸易仲裁委员会按照其当时有效的仲裁规则在上海进行仲裁，仲裁裁决为终局，对双方均有约束力。</p>
    </div>
    <p class="subtitle sm:text-lg"><b>9. 其他 </b></p>
    <ul class="A-List A-List--unordered">
        <li class="A-List__item">
            <span class="A-List__itemText">9.1 本协议的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。</span>
        </li>
        <li class="A-List__item">
            <span class="A-List__itemText">9.2 您确认所有服务条款及隐私声明并完成账户激活程序时，本协议在您与博世公司间成立并发生法律效力，同时您成为本系统正式用户。 </span>
        </li>
    </ul>
</div>
</div>
  
  